import type { ElementType, FC, PropsWithChildren } from "react";
import { Children } from "react";

import classNames from "classnames";

import { Column } from "./components/Column";

import styles from "./Row.module.scss";

type RowProps = {
  className?: string;
  component?: ElementType;
  dataTestId?: string;
  reverse?: boolean;
};

export const Row: FC<PropsWithChildren<RowProps>> = ({ children, className, component, dataTestId }) => {
  const Component = component || "div";
  Children.forEach(children, (child) => {
    if (!child) {
      return;
    }
    const isColumnElement = typeof child === "object" && "type" in child && child.type === Column;
    if (!isColumnElement) {
      throw new Error("Row component only accepts Column components as children");
    }
  });
  return (
    <Component className={classNames(styles.row, className)} data-testid={dataTestId}>
      {children}
    </Component>
  );
};
